import React from 'react'
import { connect } from 'react-redux'
import { EDIT_FOLDER_MODAL } from '@chegg-wt/core/state/modals/constants'
import { editFolder } from '@chegg-wt/core/state/folders/actions'
import { Folder } from '@chegg-wt/core/types/folders'
import { indexFromModalDataSelector as folderIndexFromModalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { folderDataFromModalDataSelector } from '@chegg-wt/core/state/folders/selectors'
import { AppState } from '@chegg-wt/core/state'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { BaseModalProps } from '../BaseModal'
import { Modal } from '..'
import FolderModalBase from './FolderModalBase'

// TODO: refactor to not use index
interface EditFolderModalProps extends BaseModalProps {
  index: number
  folder: Folder
  handleConfirm: (index: number, folder: EditFolderModalProps['folder']) => void
}

const EditFolderModal: React.FunctionComponent<EditFolderModalProps> = ({
  index,
  folder,
  handleConfirm,
  handleClose,
}) => (
  <Modal showModal closeButton outsideClick>
    <FolderModalBase
      title={`Edit folder '${folder.name}'`}
      index={index}
      handleConfirm={handleConfirm}
      handleClose={handleClose}
      folder={folder}
    />
  </Modal>
)

const mapStateToProps = (state: AppState) => ({
  // TODO: refactor to not use index
  index: folderIndexFromModalDataSelector(state),
  folder: folderDataFromModalDataSelector(state),
})

const mapDispatchToProps = {
  // TODO: refactor to not use index
  handleConfirm: (index, folder) => editFolder({ index, folder }),
  handleClose: () => closeModal(EDIT_FOLDER_MODAL),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFolderModal)
